if (!customElements.get('shipping-address')) {
  class ShippingAddress extends HTMLElement {
    constructor() {
      super();

      this.close = this.close.bind(this);
      this.open = this.open.bind(this);
      this.render = this.render.bind(this);
      this.setState = this.setState.bind(this);

      this.state = { open: false };
    }

    open() {
      this.setState({ open: true });
    }

    close() {
      this.setState({ open: false });
    }

    setState(state) {
      this.state = { ...this.state, ...state };
      this.render();
    }

    connectedCallback() {
      this.content = this.querySelector('[slot="content"]');
      this.trigger = this.querySelector('[slot="trigger"]');
      this.tooltip = this.querySelector('[slot="tooltip"]');

      this.trigger?.addEventListener('focus', this.open);
      this.trigger?.addEventListener('blur', this.close);
      this.trigger?.addEventListener('mouseenter', this.open);
      this.trigger?.addEventListener('mouseleave', this.close);

      this.storeUnsubscribe = Pmc.store.subscribe(() => {
        this.render();
      });
      this.render();
    }

    disconnectedCallback() {
      this.trigger?.removeEventListener('focus', this.open);
      this.trigger?.removeEventListener('blur', this.close);
      this.trigger?.removeEventListener('mouseenter', this.open);
      this.trigger?.removeEventListener('mouseleave', this.close);
      this.storeUnsubscribe();
    }

    render() {
      const { user } = Pmc.store.getState();
      const { open } = this.state;

      this.tooltip?.setAttribute('data-state', open ? 'open' : 'closed');

      switch (user.status) {
        case Pmc.Status.UNINITIALIZED:
        case Pmc.Status.PENDING: {
          this.content.textContent = 'Caricamento in corso...';
          break;
        }

        case Pmc.Status.REJECTED: {
          this.content.textContent = 'Errore';
          break;
        }

        case Pmc.Status.FULFILLED: {
          const address = Pmc.getUserAddress(user.data);
          if (address) {
            this.content.textContent = Pmc.formatAddress(address);
          } else {
            this.content.textContent = 'Nessun indirizzo trovato';
          }
          break;
        }
      }
    }
  }

  customElements.define('shipping-address', ShippingAddress);
}
